const state = () => ({
  firstName: '',
  lastName: '',
  email: '',
  telephoneMobile: '',
  address: {
    line1: '',
    line2: '',
    line3: '',
    town: '',
    county: '',
    postCode: ''
  },
  notes: [
    {
      noteTypeId: 3,
      ownerTypeId: 2,
      noteText: ''
    }
  ],
  contacts: [
    {
      contactTypeId: 2,
      name: '',
      mobile: '',
      otherInfo: '',
      relationship: ''
    },
    {
      contactTypeId: 3,
      name: '',
      mobile: '',
      otherInfo: ''
    }
  ],
  notificationSettings: {
    marketing: true
  },
  pets: []
})

const getters = {
  clientModel: (state) => {
    return {
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email
    }
  },
  findNote: (state) => (ownerTypeId, noteTypeId) => {
    return state.notes.find(n => n.ownerTypeId === ownerTypeId && n.noteTypeId === noteTypeId)
  },
  findPet: (state) => (petId) => {
    return state.pets.find(p => p.id === petId)
  },
  findPetNote: (state) => (petId, noteTypeId) => {
    const existing = state.pets.find(p => p.id === petId)

    if (existing) {
      return existing.petNotes.find(n => n.noteTypeId === noteTypeId)
    }
  },
  findContact: (state) => (contactTypeId) => {
    return state.contacts.find(c => c.contactTypeId === contactTypeId)
  },
  clientRegistrationModel: (state) => {
    return {
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      telephoneMobile: state.telephoneMobile,
      address: state.address,
      notes: state.notes,
      contacts: state.contacts,
      notificationSettings: state.notificationSettings,
      pets: state.pets
    }
  }
}

const mutations = {
  setFirstName (state, firstName) {
    state.firstName = firstName
  },
  setLastName (state, lastName) {
    state.lastName = lastName
  },
  setEmail (state, email) {
    state.email = email
  },
  setClientAddressLines (state, address) {
    state.address.line1 = address ? address.line1 : ''
    state.address.line2 = address ? address.line2 : ''
    state.address.line3 = address ? address.line3 : ''
    state.address.town = address ? address.town : ''
    state.address.county = address ? address.county : ''
    state.address.postCode = address ? address.postCode : ''
  },
  removePet (state, id) {
    state.pets.forEach((pet) => {
      pet.isValid = false
    })
    state.pets = state.pets.filter(p => p.id !== id)
  },
  addPet (state) {
    let newId
    do {
      newId = Math.random().toString(36).substring(7)
    } while (state.pets.some(p => p.id === newId))
    state.pets.push({
      id: newId,
      name: '',
      breedId: '',
      dateOfBirth: null,
      genderId: 2,
      neuteredId: 1,
      petNotes: [
        {
          noteTypeId: 3,
          ownerTypeId: 3,
          noteText: ''
        }
      ],
      isValid: false
    })
  },
  updatePetName (state, { petId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      existing.name = value
    }
  },
  updateBreed (state, { petId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      existing.breedId = value
    }
  },
  updateDateOfBirth (state, { petId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      existing.dateOfBirth = value
    }
  },
  updateGenderId (state, { petId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      existing.genderId = value
    }
  },
  updateNeuteredId (state, { petId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      existing.neuteredId = value
    }
  },
  updatePetNote (state, { petId, noteTypeId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      const note = existing.petNotes.find(n => n.noteTypeId === noteTypeId)

      if (note) {
        note.noteText = value
      }
    }
  },
  updatePetIsValid (state, { petId, value }) {
    const existing = state.pets.find(p => p.id === petId)
    if (existing) {
      existing.isValid = value
    }
  },
  setNoteText (state, { ownerTypeId, noteTypeId, value }) {
    const existing = state.notes.find(n => n.ownerTypeId === ownerTypeId && n.noteTypeId === noteTypeId)
    if (existing) {
      existing.noteText = value
    }
  },
  setContactName (state, { contactTypeId, value }) {
    const existing = state.contacts.find(c => c.contactTypeId === contactTypeId)
    if (existing) {
      existing.name = value
    }
  },
  setContactMobile (state, { contactTypeId, value }) {
    const existing = state.contacts.find(c => c.contactTypeId === contactTypeId)
    if (existing) {
      existing.mobile = value
    }
  },
  setContactOtherInfo (state, { contactTypeId, value }) {
    const existing = state.contacts.find(c => c.contactTypeId === contactTypeId)
    if (existing) {
      existing.otherInfo = value
    }
  },
  setMarketingSetting (state, value) {
    state.notificationSettings.marketing = value
  },
  setContactRelationship (state, { contactTypeId, value }) {
    const existing = state.contacts.find(c => c.contactTypeId === contactTypeId)
    if (existing) existing.relationship = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
